<template>
    <div class="data">
        <div class="w1200">
            <slot></slot>
            <div class="pt20">
                <el-row>
                    <el-col :span="14">
                    <el-row :gutter="50">
                        <el-col :span="5">
                            <router-link tag="div" to="/report" class="footer-router">媒体报导</router-link>
                        </el-col>
                        <el-col :span="5">
                            <router-link tag="div" to="/terms" class="footer-router">服务条款</router-link>
                        </el-col>
                        <el-col :span="5">
                            <router-link tag="div"  to="/help" class="footer-router">帮助中心</router-link>
                        </el-col>
                        <el-col :span="5">
                            <router-link tag="div"  to="/video" class="footer-router">视频教程</router-link>
                        </el-col>
                    </el-row>
                    </el-col>
                    <el-col :span="10">
                    <el-row :gutter="70">
                        <el-col :span="12">
                        <div class="f20">联系我们</div>
                        <div class="f14 mt10">工作时间: 8:30-17:30(周六日双休)</div>
                        <div class="f14">公司电话：0551-65306546</div>
                        <div class="f14">企业邮箱：contact@zegroup.cn</div>
                        </el-col>
                        <el-col :span="12">
                        <div class="f20">极书公众号</div>
                        <div class="mt10">
                            <span class="tc" style="display:inline-block">
                            <img src="../../static/img/4.0.2/teacher-code.png" alt="">
                            <span class="f14">教师端</span>
                            </span>
                            <span class="tc ml10" style="display:inline-block">
                            <img src="../../static/img/4.0.2/teacher-code.png" alt="">
                            <span class="f14">学生端</span>
                            </span>
                        </div>
                        </el-col>
                    </el-row>
                    </el-col>
                </el-row>
                </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{}
    }
}
</script>

<style scoped>

.data{
  background: url('../../static/img/4.0.2/bg.png') no-repeat center;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding:100px 0 30px;
  color:#fff;
}
.footer-router{
  width: 120px;
  height: 120px;
  border: 1px solid #fff;
  line-height: 120px;
  text-align: center;
  cursor: pointer;
}
.footer-router:hover{
  background:rgba(255,255,255, .6);
  color:#ce1212;
}
.footer-router.active{
    background:rgba(255,255,255, .6);
  color:#ce1212;
}
</style>


// WEBPACK FOOTER //
// src/components/footerNav.vue